import { render, staticRenderFns } from "./ApprovalLevel.vue?vue&type=template&id=0fd01ce2"
import script from "./ApprovalLevel.vue?vue&type=script&lang=js"
export * from "./ApprovalLevel.vue?vue&type=script&lang=js"
import style0 from "./ApprovalLevel.vue?vue&type=style&index=0&id=0fd01ce2&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports